import type { EntityKind, ParkState } from '../types';
import { distinctAttractionKindCount } from './kioskCapacity';

/** True until any attraction kind has ever been built (milestone or live entity). */
export function starterGateActive(state: ParkState): boolean {
  return distinctAttractionKindCount(state) === 0;
}

export function evaluateStarterBuild(
  state: ParkState,
  kind: EntityKind,
): { ok: true } | { ok: false; reason: 'starter_gate' } {
  if (!starterGateActive(state) || kind === 'starter_ride') {
    return { ok: true };
  }
  return { ok: false, reason: 'starter_gate' };
}

export function evaluateStarterCoinSpend(
  state: ParkState,
): { ok: true } | { ok: false; reason: 'starter_gate' } {
  if (!starterGateActive(state)) {
    return { ok: true };
  }
  return { ok: false, reason: 'starter_gate' };
}
